import PropTypes from "prop-types";

const artistShape = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  year_born: PropTypes.string,
  year_died: PropTypes.string,
  dates: PropTypes.string,
  lifespan: PropTypes.string,
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
  show_bio: PropTypes.number,
};

const exhibitionShape = {
  id: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  display_name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  image_default: PropTypes.string,
  image_retina: PropTypes.string,
  featured_image_default: PropTypes.string,
  featured_image_retina: PropTypes.string,
  image_alt: PropTypes.string,
  date_range: PropTypes.string.isRequired,
  location_start: PropTypes.string,
  location_end: PropTypes.string,
  location_details: PropTypes.string,
};

const eventShape = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  short_name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  image_default: PropTypes.string,
  image_retina: PropTypes.string,
  image_alt: PropTypes.string,
  description: PropTypes.string,
};

const svgShape = {
  size: PropTypes.number,
  styleProps: PropTypes.object,
  className: PropTypes.string,
};

export { artistShape, exhibitionShape, eventShape, svgShape };
